import { CohabitationDetailForm } from 'cohabitation/view-models/detail-cohabitation';
import { DateTime } from 'luxon';
import { GivenHeaderData } from 'shell/models/person';
import { FamilyCoexistence } from 'shell/models/person/family';
import { Residence } from 'shell/models/person/residence';

interface RequestEditCohabition {
  famigliaConvivenza?: FamilyCoexistence;
  residenzaFamigliaConvivenza?: Residence;
  testataRichiesta?: GivenHeaderData;
  datiControllo: {
    tipoMutazione: string;
    tipoScheda: string;
  };
}

export const transformerRequestEditCohabitation = (
  values: CohabitationDetailForm
): RequestEditCohabition => {
  const famigliaConvivenza = {
    dataOrigineFamigliaConvivenza:
      values?.accordionCohabitation?.originDate?.toFormat('yyyy-MM-dd'),
    denominazioneConvivenza: values?.accordionCohabitation?.nameCohabitation,
    idFamigliaConvivenzaANPR: values?.accordionCohabitation?.idANPR,
    idFamigliaConvivenzaComune:
      values?.accordionCohabitation?.municipalityIdentifier ||
      values?.accordionCohabitation?.istatCode
        ? {
            idFamigliaConvivenza: values?.accordionCohabitation?.municipalityIdentifier,
            idFamigliaConvivenzaComuneIstat: values?.accordionCohabitation?.istatCode,
          }
        : undefined,
    specieConvivenza: values?.accordionCohabitation?.kindCohabitation,
    tipoScheda: values?.accordionCohabitation?.tipoScheda,
    tipoMovimentazione: values?.accordionCohabitation?.tipoMovimentazione,
    presenzaFamigliaCoabitante: values?.accordionCohabitation?.presenzaFamigliaCoabitante,
    motivoCostituzione: values?.accordionCohabitation?.motivoCostituzione,
    famigliaAire: values?.accordionCohabitation?.famigliaAire,
  };

  const hasInternalCivic =
    !!values?.residence?.court ||
    !!values?.residence?.exponentFirstIntern ||
    !!values?.residence?.exponentSecondaryIntern ||
    !!values?.residence?.firstIntern ||
    !!values?.residence?.secondaryIntern ||
    !!values?.residence?.isolated ||
    !!values?.residence?.nui ||
    !!values?.residence?.floor ||
    !!values?.residence?.scale ||
    !!values?.residence?.externalScale ||
    !!values?.residence?.secondary;

  const residenzaFamigliaConvivenza: Residence = {
    dataDecorrenzaResidenza: values?.residence?.effectiveDate?.toFormat('yyyy-MM-dd') || '',
    tipoIndirizzo: values?.residence?.type || undefined,
    indirizzo: {
      cap: values?.residence?.cap || undefined,
      comune: {
        codiceIstat: values?.residence?.municipality?.id,
        nomeComune: values?.residence?.municipality?.description,
        siglaProvinciaIstat: values?.residence?.municipality?.province,
        descrizioneLocalita: values?.residence?.locality,
      },
      frazione: values?.residence?.at, // TODO
      toponimo: {
        denominazioneToponimo: values?.residence?.name || undefined,
        codToponimo: values?.residence?.code || undefined,
        codSpecie: values?.residence?.kindCode || undefined,
        specie: values?.residence?.kind || undefined,
        specieFonte: values?.residence?.kindSource || undefined,
        toponimoFonte: values?.residence?.source || undefined,
        // Campi mancanti???
      },
      numeroCivico: {
        numero: values?.residence?.number || undefined,
        esponente1: values?.residence?.exponent || undefined,
        lettera: values?.residence?.letter || undefined,
        civicoFonte: values?.residence?.sourceCivic || undefined,
        civicoInterno: hasInternalCivic
          ? {
              corte: values?.residence?.court || undefined,
              espInterno1: values?.residence?.exponentFirstIntern || undefined,
              espInterno2: values?.residence?.exponentSecondaryIntern || undefined,
              interno1: values?.residence?.firstIntern || undefined,
              interno2: values?.residence?.secondaryIntern || undefined,
              isolato: values?.residence?.isolated || undefined,
              nui: values?.residence?.nui || undefined,
              piano: values?.residence?.floor || undefined,
              scala: values?.residence?.scale || undefined,
              scalaEsterna: values?.residence?.externalScale || undefined,
              secondario: values?.residence?.secondary || undefined,
            }
          : undefined,
        codiceCivico: values?.residence?.civicCode,
        colore: values?.residence?.color,
        metrico: values?.residence?.metric,
        progSNC: values?.residence?.prog,
        // mancano altri campi ???
      },
    },
  };

  return {
    famigliaConvivenza,
    residenzaFamigliaConvivenza,
    datiControllo: {
      tipoMutazione: '4',
      tipoScheda: '1',
    },
    testataRichiesta: {
      dataDecorrenza:
        values?.editDataControl?.dateValidity?.toFormat('yyyy-MM-dd') ||
        DateTime.now().toFormat('yyyy-MM-dd'),
    },
  };
};
